var map = {
	"./announcement-bar": 95,
	"./announcement-bar.js": 95,
	"./appointment-booker-modal": 94,
	"./appointment-booker-modal.js": 94,
	"./blocks-item": 93,
	"./blocks-item.js": 93,
	"./carousel": 92,
	"./carousel-watch-css": 88,
	"./carousel-watch-css-no-nav": 87,
	"./carousel-watch-css-no-nav.js": 87,
	"./carousel-watch-css.js": 88,
	"./carousel-with-nav": 86,
	"./carousel-with-nav-in-modal": 85,
	"./carousel-with-nav-in-modal.js": 85,
	"./carousel-with-nav.js": 86,
	"./carousel.js": 92,
	"./collection-per-page": 84,
	"./collection-per-page.js": 84,
	"./collection-sort-by": 83,
	"./collection-sort-by.js": 83,
	"./competition-terms": 82,
	"./competition-terms.js": 82,
	"./cookie-banner": 81,
	"./cookie-banner.js": 81,
	"./customer-login": 80,
	"./customer-login.js": 80,
	"./delivery-selector": 79,
	"./delivery-selector.js": 79,
	"./drawer-collection-filters": 78,
	"./drawer-collection-filters.js": 78,
	"./drawers": 77,
	"./drawers.js": 77,
	"./faqs-section": 76,
	"./faqs-section.js": 76,
	"./header": 75,
	"./header.js": 75,
	"./load-more": 74,
	"./load-more.js": 74,
	"./mobile-accordion": 64,
	"./mobile-accordion.js": 64,
	"./modals": 63,
	"./modals.js": 63,
	"./page-nav": 62,
	"./page-nav.js": 62,
	"./parallax": 61,
	"./parallax.js": 61,
	"./product-accordion": 60,
	"./product-accordion.js": 60,
	"./product-image-gallery": 59,
	"./product-image-gallery.js": 59,
	"./product-mobile": 58,
	"./product-mobile.js": 58,
	"./read-more": 57,
	"./read-more.js": 57,
	"./rich-text": 56,
	"./rich-text.js": 56,
	"./search": 55,
	"./search.js": 55,
	"./store-finder": 54,
	"./store-finder.js": 54,
	"./store-switcher": 53,
	"./store-switcher.js": 53,
	"./video": 52,
	"./video.js": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;